export const TESCO_LOGO = 'https://1000logos.net/wp-content/uploads/2023/04/Tesco-logo.png';
export const INPUT_MAX_LENGTH = 64;

export const ROADMAP_ITEM_WIDTH = 400;
export const ROADMAP_ITEM_HEIGHT = 220;
export const ROADMAP_ITEM_GAP = 20;
export const DATE_FORMAT = 'DD/MM/YYYY';

export const SUPPORTED_DATE_FORMATS = [
  'DD/MM/YYYY',
  'D/M/YYYY',
  'DD-MM-YYYY',
  'D-M-YYYY',
  'DD.MM.YYYY',
  'D.M.YYYY',
];

export const SUPPORTED_CURRENCIES = [
  { id: 1, currency: 'GBP', symbol: '£' },
  { id: 2, currency: 'EUR', symbol: '€' },
  { id: 3, currency: 'USD', symbol: '$' },
  { id: 4, currency: 'AUD', symbol: 'A$' },
  { id: 5, currency: 'CAD', symbol: 'C$' },
  { id: 6, currency: 'AED', symbol: 'د.إ' },
  { id: 7, currency: 'JPY', symbol: '¥' },
  { id: 8, currency: 'CNY', symbol: '¥' },
  { id: 9, currency: 'DKK', symbol: 'kr' },
  { id: 10, currency: 'HKD', symbol: 'HK$' },
  { id: 11, currency: 'INR', symbol: '₹' },
  { id: 12, currency: 'NOK', symbol: 'kr' },
  { id: 13, currency: 'QAR', symbol: 'ر.ق' },
  { id: 14, currency: 'SAR', symbol: 'ر.س' },
  { id: 15, currency: 'SGD', symbol: 'S$' },
  { id: 16, currency: 'SEK', symbol: 'kr' },
  { id: 17, currency: 'ZAR', symbol: 'R' },
  { id: 18, currency: 'PKR', symbol: '₨' },
  { id: 19, currency: 'NZD', symbol: 'NZ$' },
];

export const CURRENCY_SYMBOL_TO_CODE_MAP = {
  '£': 'GBP',
  $: 'USD',
  '€': 'EUR',
  C$: 'CAD',
  A$: 'AUD',
  'د.إ': 'AED',
  '¥': 'JPY', // Note: same symbol for JPY and CNY
  kr: 'DKK', // Note: same symbol for DKK, NOK, SEK
  HK$: 'HKD',
  '₹': 'INR',
  'ر.ق': 'QAR',
  'ر.س': 'SAR',
  S$: 'SGD',
  R: 'ZAR',
  '₨': 'PKR',
  NZ$: 'NZD',
} as const;

export const CURRENCY_CODE_TO_SYMBOL_MAP = {
  GBP: '£',
  USD: '$',
  EUR: '€',
  AUD: 'A$',
  CAD: 'C$',
  AED: 'د.إ',
  JPY: '¥',
  CNY: '¥',
  DKK: 'kr',
  HKD: 'HK$',
  INR: '₹',
  NOK: 'kr',
  QAR: 'ر.ق',
  SAR: 'ر.س',
  SGD: 'S$',
  SEK: 'kr',
  ZAR: 'R',
  PKR: '₨',
  NZD: 'NZ$',
} as const;

export const CURRENCY_CODE = {
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
  AUD: 'AUD',
  CAD: 'CAD',
  AED: 'AED',
  JPY: 'JPY',
  CNY: 'CNY',
  DKK: 'DKK',
  HKD: 'HKD',
  INR: 'INR',
  NOK: 'NOK',
  QAR: 'QAR',
  SAR: 'SAR',
  SGD: 'SGD',
  SEK: 'SEK',
  ZAR: 'ZAR',
  PKR: 'PKR',
  NZD: 'NZD',
} as const;

export const ServiceStatusCodes = {
  OK: 200,
  MAINTENANCE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;
